/* global BX24 */
import { useEffect } from "react";
import bitrixResize from "../../utils/bitrixResize";
const PATH_TO_BACKEND = process.env.REACT_APP_PATH_TO_BACKEND;

const regions = [
  { value: "СПБ", label: "Санкт-Петербург", coordinates: { lat: 59.9343, lng: 30.3351 } },
  { value: "МСК", label: "Москва", coordinates: { lat: 55.7558, lng: 37.6173 } },
  { value: "КРД", label: "Краснодар", coordinates: { lat: 45.0355, lng: 38.9753 } },
];

const Bitrix = ({ setDealId, setClientName, setLocationFromDeal, setSelfPickUp, setSelectedRegion, setDeliveryDate, setIsBitrix }) => {
  const getRegionFallbackPoint = (regionCode) => {
    const match = regions.find((r) => r.value === regionCode) || regions[0];
    return {
      region: match.value,
      address: `${match.label}, Россия`,
      coordinates: {
        latitude: parseFloat(match.coordinates.lat),
        longitude: parseFloat(match.coordinates.lng),
      },
    };
  };

  const applyRegionFallback = async (dealId) => {
    try {
      const response = await fetch(`${PATH_TO_BACKEND}/api/address_clientname/region`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ dealId }),
      });

      if (!response.ok) {
        throw new Error(`fallback /region ${response.status}`);
      }

      const data = await response.json();
      const fallback = getRegionFallbackPoint(data.region || "СПБ");
      setSelectedRegion(fallback.region);
      setLocationFromDeal({
        address: fallback.address,
        coordinates: fallback.coordinates,
      });
      setSelfPickUp(false);
      console.log("⚙️ Применен fallback адреса по региону:", fallback);
    } catch (err) {
      setLocationFromDeal(null);
      console.error("⚠️ Не удалось применить fallback адреса по региону:", err);
    }
  };

  useEffect(() => {
    if (typeof BX24 === "undefined") {
      console.warn("⚠️ BX24 API не загружен. Приложение работает вне Bitrix24.");
      return;
    }

    try {
      BX24.init(() => {
        console.log("✅ BX24 API успешно инициализирован.");
        setIsBitrix(true)
        const placementInfo = BX24.placement?.info?.();

        if (placementInfo?.options?.ID) {
          const bxDealId = placementInfo.options.ID.toString();
          console.log("✅ ID сделки:", bxDealId);
          if (typeof setDealId === "function") {
            setDealId(bxDealId);
          } else {
            console.warn("⚠️ setDealId не является функцией, пропускаем вызов.");
          }
          fetchClientName(bxDealId);
          
          bitrixResize.init();
          bitrixResize.forceResize();
        } else {
          console.warn("❌ Не удалось получить ID сделки.");
        }
      });
    } catch (error) {
      setIsBitrix(false)
      console.warn("⚠️ Ошибка инициализации BX24 API:", error);
      // setSelectedRegion("СПБ");
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchClientName = async (dealId) => {
    if (!dealId) {
      console.warn("⚠️ ID сделки не передан, пропускаем запрос.");
      return;
    }

    try {
      const response = await fetch(`${PATH_TO_BACKEND}/api/address_clientname?dealId=${encodeURIComponent(dealId)}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ dealId }),
      });

      if (!response.ok) {
        setLocationFromDeal(null);
        const errorText = await response.text();
        await applyRegionFallback(dealId);
        console.warn(`⚠️ /api/address_clientname вернул ${response.status}, применен fallback по региону: ${errorText}`);
        return;
      }
      

      const data = await response.json();
      console.log("все данные из сделки:", {data});

      console.log("✅ Имя клиента из сделки:", data.contactName);
      console.log("✅ Самовывоз из сделки:", data.selfPickUp);
      console.log("✅ Адрес из сделки:", data.address);
      console.log("✅ Координаты из сделки:", data.coordinates);

      setClientName(data.contactName);
      setSelfPickUp(data.selfPickUp);
      setLocationFromDeal({
        address: data.address,
        coordinates: data.coordinates,
      });
      setSelectedRegion(data.region);
      setDeliveryDate(data.deliveryDate || '');

    } catch (error) {
      console.error("⚠️ Ошибка запроса к API /api/address_clientname:", error);
    }
  };

  return null; // Компонент не рендерит ничего, только передает данные в родительский компонент
};

export default Bitrix;
